import { makeStyles } from 'tss-react/mui';

const useStylesFixedBottomContainer: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  fixedBottomContainerActive: {
    position: 'fixed',
    bottom: 0,
    right: 0,
    zIndex: 1000,
    width: 365,
    height: 55,
    background: 'none !important',
    paddingRight: 35,
    [theme.breakpoints.down('md')]: {
      paddingRight: 0,
      marginRight: -10,
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      margin: '0 auto',
    },
  },
  fixedBottomContainerOffset: {
    right: 300,
    [theme.breakpoints.down('lg')]: {
      right: 0,
    },
  },
}));

export default useStylesFixedBottomContainer;
